import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './IconBin.module.css';

/**
 * Trash/Delete bin icon
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className - add more style rules in addition to component's own css.root
 * @param {string?} props.rootClassName - overwrite component's own css.root
 * @returns {JSX.Element} SVG icon
 */
const IconBin = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 6 7"
      fill="currentColor"
    >
      <path d="M1 7l4 0c0,0 0,-1 0,-1 0,0 0,0 0,0 0,0 0,-1 0,-1 0,0 0,0 0,0l0 -1c0,0 0,0 0,0 0,0 0,0 0,0 0,-1 0,-1 0,-1 0,0 0,0 0,0 0,0 0,-1 0,-1l0 0 -5 0 1 2c0,0 0,1 0,1 0,0 0,0 0,0l0 1c0,0 0,1 0,1z" />
      <path d="M2 0l-2 0c0,0 0,1 0,1 0,0 0,0 0,0l6 0c0,0 0,0 0,0 0,-1 0,-1 -1,-1l-1 0c0,0 0,0 0,0l-2 0c0,0 0,0 0,0z" />
    </svg>
  );
};

IconBin.defaultProps = {
  className: null,
  rootClassName: null,
};

IconBin.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default IconBin;
